import React, { Component } from "react";
import { Header, Button, Modal, Icon } from 'semantic-ui-react';
import { resetCustomField, saveCustomField } from '../../actions/customFields/saveAndCancelCustomField';
import { customFieldEdited } from '../../actions/customFields/editCustomFields';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createNotification, NOTIFICATION_TYPE_SUCCESS, NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_WARNING } from 'react-redux-notify';
try {
    var userDetails = atob(localStorage.getItem("userDetails"));
    if (userDetails) {
        userDetails = JSON.parse(userDetails);
    }
} catch (e) {
    window.location.reload();
}
const firmID = userDetails ? userDetails.UserContext.firmId : 697;
var loggedInUserId = userDetails ? userDetails.UserContext.userId : 16192;
class CustomFieldConfirmModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false
        }
        this.successNotification = {
            type: NOTIFICATION_TYPE_SUCCESS,
            duration: 5000,
            canDismiss: true,
        }
        this.errorNotification = {
            type: NOTIFICATION_TYPE_ERROR,
            duration: 5000,
            canDismiss: true,
        }

    }

    handleOpen = () => {
        if (this.props.isCfieldsedited) {
            this.setState({ modalOpen: true })
        } else {
            window.history.back();
        }

    }

    handleSaveClose = () => {
        var _this = this;
        let emptyOptionsCount = 0;
        this.props.firmCustomFields.map(element => {
            element.fieldName = element.fieldName.trim();
            element.updatedBy = loggedInUserId;
            if (element.fieldType === 'Single Select' && element.customFieldOptions.length === 0) {
                emptyOptionsCount++;
            }
            return element;
        });
        let _emptyField = this.props.firmCustomFields.filter(cField => cField.fieldName.trim() === "");
        let _uniqFieldName = [...new Set(this.props.firmCustomFields.map(cField => cField.fieldName.trim()))];

        if (_emptyField.length) {
            const blankCfieldNotification = {
                message: `There must be a Custom Field Name.`,
                ...this.errorNotification
            }
            this.setState({ modalOpen: false });
            this.props.createNotification(blankCfieldNotification);
        } else if (_uniqFieldName.length < this.props.firmCustomFields.length) {
            const existsNotification = {
                message: `Custom Field Name already exists`,
                ...this.errorNotification
            }
            this.setState({ modalOpen: false });
            this.props.createNotification(existsNotification);
        } else if (emptyOptionsCount !== 0) {
            const mustOptionNotification = {
                message: `All dropdown fields must have one or more options.`,
                ...this.errorNotification
            }
            this.setState({ modalOpen: false });
            this.props.createNotification(mustOptionNotification);
        }
        else {
            const saveNotification = {
                message: `Saved Successfully`,
                ...this.successNotification
            }
            let savePromise = this.props.saveCustomField(this.props.firmCustomFields, firmID);
            savePromise.then((response) => {
                if (response.statusCode === 200) {
                    _this.props.createNotification(saveNotification);
                    _this.setState({ modalOpen: false });
                    setTimeout(() => {
                        window.history.back();
                    }, 500)
                }
            }).catch((response) => {
                console.log('error in saving the data', response)
            });
        }
    }

    handleCloseNotSave = () => {
        this.props.resetCustomField(this.props.originalFirmCustomFields);
        this.setState({ modalOpen: false });
        const discardNotification = {
            message: `Changes Discarded Successfully`,
            ...this.successNotification
        }
        this.props.createNotification(discardNotification);
        setTimeout(() => {
            window.history.back();
        }, 1000)

    }

    render() {
        return (
            <Modal className="confirmModal"
                open={this.state.modalOpen}
                onClose={this.handleClose}
                trigger={<Button basic icon className="border-0 only-icon" onClick={this.handleOpen}>
                    <Icon className='xcm-icon-close size-24 color-wk-primary-gray' />
                </Button>}>
                <Header content="Cancel" />
                <Modal.Content>
                    <p> You have unsaved changes below. Do you want to Save & Close or Close without Saving?</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button basic fluid inverted color='green' onClick={this.handleSaveClose}>
                        Save & Close
                        </Button>
                    <Button basic fluid inverted color='red' onClick={this.handleCloseNotSave}>
                        Close without Saving
                        </Button>
                </Modal.Actions>
            </Modal>
        )

    }
}

function mapStatetoprops(state) {
    return {
        originalFirmCustomFields: state.customFieldsReducer.originalFirmCustomFields,
        isCfieldsedited: state.customFieldsReducer.isCustomFieldEdited,
        firmCustomFields: state.customFieldsReducer.firmCustomFields,
        createNotification: state.customFieldsReducer.createNotification
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            customFieldEdited,
            resetCustomField,
            saveCustomField,
            createNotification
        },
        dispatch
    )
}

export default connect(mapStatetoprops, mapDispatchToProps)(CustomFieldConfirmModal);